import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { UpdateTXUserFormValues } from '@/types/customer';
import { TXUserRoleUpdateForm } from '../../TXRoleForm';

type Props = {
  isReadOnly?: boolean;
  fields: Record<'id', string>[];
};

export const UpdateRolesList = React.memo(({ isReadOnly = false, fields }: Props) => {
  const { control } = useFormContext<UpdateTXUserFormValues>();

  const customerInTxCenters = useWatch({
    control,
    name: 'customerInTxCenters',
  });

  return (
    <>
      {fields.map((field, index) => {
        const center = customerInTxCenters?.[index];
        if (!center) return null;

        return (
          <TXUserRoleUpdateForm
            key={field.id}
            isReadOnly={isReadOnly}
            index={index}
            txCenterName={center.txCenter?.name || ''}
          />
        );
      })}
    </>
  );
});

UpdateRolesList.displayName = 'UpdateRolesList';
